import React from "react";
import { useDispatch } from "react-redux";
import { Controller } from "react-hook-form";
import { useEdit } from "../hooks/useEdit";
import { MainModal } from "../../../../components/modal/MainModal";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";
import { resetStatus } from "../redux/storesSagas";
import { useError } from "../../../../hooks/useError";
import { Input } from "../../../../components/form/Input/Input";
import ToggleableButton from "../../../../components/toggleableButton/toggleableButton";
import ReactDatePicker from "../../../../components/reactDatePicker/reactDatePicker";
import { ErrorList } from "../../../../components/ErrorList";
import { showToast } from "../../../../utils/showToast";

export const Edit = ({ isOpen, onClose, selected: { id, name: orgName } }) => {
  const dispatch = useDispatch();
  const {
    form: { register, control, formState: { errors, dirtyFields, isLoading } = {} } = {},
    submit
  } = useEdit({ id, orgName });

  const close = () => {
    dispatch(resetStatus());
    onClose();
  };

  const { errors: serverErrors, status } = useError({
    cb: () => {
      showToast("Store was successfully updated");
      close();
    },
    sliceKey: "stores"
  });

  const primaryButtonDisabled =
    (dirtyFields && Object.keys(dirtyFields).length === 0) || status == "pending";
  return (
    <>
      <MainModal
        isLoading={isLoading}
        parentSelector=".stores"
        isOpen={isOpen}
        onClose={close}
        headerText={
          <>
            Edit Store - <span className="text-bold">{orgName}</span>
          </>
        }
        headerCloseHandler={close}
        height="auto"
        width={900}
        primaryButtonText="Save"
        primaryBtnHandler={submit}
        primaryButtonDisabled={primaryButtonDisabled}
        secondaryBtnText="Cancel"
        secondaryBtnHandler={close}
        containerClassName="edit"
      >
        <div className="stores__info">
          <div className="stores__section">
            <Input
              label="Store Id"
              htmlFor="remote_uid"
              customProps={{ ...register("remote_uid"), disabled: true }}
            />
            <Input
              label="Organization"
              htmlFor="organization_name"
              disabled
              customProps={{ ...register("organization_name"), disabled: true }}
            />
            <div className="switch">
              <p className="switch__title">Inactive</p>
              <Controller
                control={control}
                name="inactive"
                render={({ field: { onChange, value } }) => {
                  return (
                    <div className={`switch__content ${value ? "switch__content--active" : ""}`}>
                      <ToggleableButton
                        isRadio
                        title="inactive"
                        isActive={value}
                        onClick={(isActive) => onChange(isActive)}
                      />
                    </div>
                  );
                }}
              />
            </div>
            <div className="switch">
              <p className="switch__title">Force Active</p>
              <Controller
                control={control}
                name="force_active"
                render={({ field: { onChange, value } }) => {
                  return (
                    <div className={`switch__content ${value ? "switch__content--active" : ""}`}>
                      <ToggleableButton
                        isRadio
                        title="force active"
                        isActive={value}
                        onClick={(isActive) => onChange(isActive)}
                      />
                    </div>
                  );
                }}
              />
            </div>
          </div>
          <div className="stores__section">
            <Input label="Name" htmlFor="name" customProps={register("name")} />
            <Input
              label="Chain"
              htmlFor="clubready_chain_uid"
              customProps={{ ...register("clubready_chain_uid"), disabled: true }}
            />
            <div className="switch">
              <p className="switch__title">Opened</p>
              <Controller
                control={control}
                name="opened"
                render={({ field: { onChange, value } }) => {
                  return (
                    <div className={`switch__content ${value ? "switch__content--active" : ""}`}>
                      <ToggleableButton
                        isRadio
                        title="Opened"
                        isActive={value}
                        onClick={(isActive) => onChange(isActive)}
                      />
                    </div>
                  );
                }}
              />
            </div>
          </div>
          <div className="stores__section">
            <div className="admin-users__date">
              <p>First Calculation Date</p>
              <Controller
                control={control}
                name="first_calculation_date"
                render={({ field: { onChange, onBlur, value } }) => {
                  return (
                    <ReactDatePicker
                      showDefaultInputIcon={false}
                      showClearDate
                      onBlur={onBlur}
                      startDate={value}
                      allowAllDays
                      updateDates={(data) => onChange(data)}
                    />
                  );
                }}
              />
            </div>
            <div className="admin-users__date">
              <p>First revenue calc date</p>
              <Controller
                control={control}
                name="first_revenue_calculation_date"
                render={({ field: { onChange, onBlur, value } }) => {
                  return (
                    <ReactDatePicker
                      showDefaultInputIcon={false}
                      showClearDate
                      onBlur={onBlur}
                      startDate={value}
                      allowAllDays
                      updateDates={(data) => onChange(data)}
                    />
                  );
                }}
              />
            </div>
          </div>
        </div>
        {status === "pending" && <LoadingAnimation uiLoader />}
        <ErrorList errors={{ ...errors, ...serverErrors }} />
      </MainModal>
    </>
  );
};
